// @ts-nocheck

import debugLib from 'debug';
import * as R from 'ramda';
import { GOOGLE_ADWORDS_MACHINE_NAME } from '../../../../shared/constants/adPartnerConstants';
import { GET_GOOGLE_ACCOUNTS, VALIDATE_GOOGLE_LINK_IDS } from '../actions/GoogleActions';
import { GET_AD_ACCOUNT_STATUS } from '../actions/SANPartnerActions';
import { reducerWrapper } from '../support/utils';
const debug = debugLib('GoogleReducer');
const INIT_STATE = {
  accounts: [],
  userInfo: {},
  adAccountStatus: {},
  linkIdValidationResult: {},
};

function Handler(state = INIT_STATE, action) {
  debug('Receive action type', action.type);

  switch (action.type) {
    case GET_GOOGLE_ACCOUNTS.response:
      const { accounts } = action.data;
      return R.merge(state, {
        accounts,
        loading: false,
      });

    case GET_AD_ACCOUNT_STATUS.response:
      const adAccountStatus = R.path([GOOGLE_ADWORDS_MACHINE_NAME], action.data) || {};
      return R.merge(state, {
        adAccountStatus,
      });

    case VALIDATE_GOOGLE_LINK_IDS.response:
      return { ...state, linkIdValidationResult: action.data };

    default:
      return state;
  }
}

const Google = reducerWrapper(INIT_STATE, Handler, {
  request: [GET_GOOGLE_ACCOUNTS, GET_AD_ACCOUNT_STATUS, VALIDATE_GOOGLE_LINK_IDS],
  error: [GET_GOOGLE_ACCOUNTS, GET_AD_ACCOUNT_STATUS, VALIDATE_GOOGLE_LINK_IDS],
  resetOn: ['APP_CHANGE'],
});
export default Google;
